module.exports = {"first":"Eerste","previous":"Vorige","next":"Volgende","last":"Laatste","yes":"Ja","no":"Nee","changedlocale":"Van taal veranderd"};